<template>
    <div id="left-bar-stocks">
        <ul>
            <li class="menu-title text-center">
                <i class="fab fa-stack-overflow"></i>
                {{ $t("LeftBarStocks.stocks") }}
            </li>
            <li class="has_sub active">
                <router-link to="/stocks/dashboard" class="waves-effect active">
                    <i class="fa fa-chart-line"></i>
                    <span> {{ $t("LeftBarStocks.dashboard") }} </span>
                </router-link>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
    name: "LeftBarStocks",
};
</script>

<style lang="scss">
    @import "../../../assets/scss/colors";

    #left-bar-stocks {
        .waves-effect {
            &.active {
                border-left-color: $stocks-color;
                i {
                    color: $stocks-color;
                }
            }
            .waves-ripple {
                background-color: rgba($stocks-color, 0.45) !important;
            }
        }
    }
</style>